import Reveal from "@/components/base/Reveal";
import SectionTag from "@/components/base/SectionTag";
import { verifyFlow } from "@/mocks/content";

export default function VerifySection() {
  return (
    <section className="w-full bg-background-100 py-20 md:py-28" id="verification">
      <div className="mx-auto w-full max-w-[1320px] px-5 md:px-8">
        <div className="max-w-2xl">
          <SectionTag tone="accent">我们怎么处理线索</SectionTag>
          <h2 className="mt-5 font-heading text-2xl font-bold leading-snug text-foreground-950 md:text-4xl">
            一条线索进入之后的六个环节
          </h2>
          <p className="mt-4 text-sm leading-7 text-foreground-600 md:text-[15px]">
            公开是最后一步，而不是第一步。在此之前，材料要经过登记、研判、交叉核验与脱敏，每一环都可以叫停。
          </p>
        </div>

        <div className="mt-12 grid grid-cols-1 gap-x-8 gap-y-8 sm:grid-cols-2 lg:grid-cols-3">
          {verifyFlow.map((item, index) => (
            <Reveal key={item.title} delay={index * 60}>
              <article className="relative h-full rounded-lg border border-background-200 bg-background-50 p-6">
                <div className="flex items-center justify-between">
                  <span className="font-heading text-3xl font-bold text-background-300">
                    {String(index + 1).padStart(2, "0")}
                  </span>
                  <span className="h-2 w-2 rounded-full bg-accent-400"></span>
                </div>
                <h3 className="mt-4 font-heading text-base font-semibold text-foreground-950">{item.title}</h3>
                <p className="mt-2 text-sm leading-7 text-foreground-600">{item.desc}</p>
              </article>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}